import {
    AccountReconProductFeatureModelDto,
    AchProductModelDto,
    CompanyBillPayProductModelDto,
    ElectronicDocumentProductModelDto,
    InformationReportingProductFeatureModelDto,
    ProductFeatureModelDto,
    RemoteDepositProductModelDto,
    StopPaymentProductFeatureModelDto,
    TransferProductFeatureModelDto,
    WausauStatementsProductModelDto,
    WireTransferDliProductFeatureModelDto,
    WireTransferProductFeatureModelDto,
} from '@treasury/api/bo';
import {
    AccountReconProductFeature,
    AchProductFeature,
    AgileticsWebEscrowProductFeature,
    BillPayProductFeature,
    ElectronicDocumentsProductFeature,
    ForeignCurrencyWireProductFeature,
    PositivePayProductFeature,
    RemoteDepositCaptureProductFeature,
    ReportingProductFeature,
    StopPaymentProductFeature,
    TransferProductFeature,
    WausauEStatementsProductFeature,
    WireProductFeature,
} from '../entities';
import { FeatureApiType, SpecificCompanyProductFeature } from '../types';

export const mapProductFeatureDto = (
    model: ProductFeatureModelDto,
    featureType: FeatureApiType
): SpecificCompanyProductFeature => {
    // TODO: As we implement the other features update the model passed to each constructor to be cast as the correct (tbd) DTO type
    switch (featureType) {
        case FeatureApiType.ACH:
            return new AchProductFeature(model as AchProductModelDto);
        case FeatureApiType.AccountRecon:
            return new AccountReconProductFeature(model as AccountReconProductFeatureModelDto);
        case FeatureApiType.Agiletics:
            return new AgileticsWebEscrowProductFeature(model);
        case FeatureApiType.BillPay:
            return new BillPayProductFeature(model as CompanyBillPayProductModelDto);
        case FeatureApiType.ElectronicDocuments:
            return new ElectronicDocumentsProductFeature(
                model as ElectronicDocumentProductModelDto
            );
        case FeatureApiType.ForeignCurrencyWire:
            return new ForeignCurrencyWireProductFeature(
                model as WireTransferDliProductFeatureModelDto
            );
        case FeatureApiType.PositivePay:
            return new PositivePayProductFeature(model);
        case FeatureApiType.RemoteDeposit:
            return new RemoteDepositCaptureProductFeature(model as RemoteDepositProductModelDto);
        case FeatureApiType.Reporting:
            return new ReportingProductFeature(model as InformationReportingProductFeatureModelDto);
        case FeatureApiType.StopPayment:
            return new StopPaymentProductFeature(model as StopPaymentProductFeatureModelDto);
        case FeatureApiType.Transfer:
            return new TransferProductFeature(model as TransferProductFeatureModelDto);
        case FeatureApiType.Wausau:
            return new WausauEStatementsProductFeature(model as WausauStatementsProductModelDto);
        case FeatureApiType.Wire:
            return new WireProductFeature(model as WireTransferProductFeatureModelDto);
        default:
            throw new Error(`Feature not implemented: ${model.type}`);
    }
};
